import React from 'react'
import StoreFormPage from '../../components/Merchant/StoreForm';

const StoreForm = () => {
  return (
    <StoreFormPage />
  )
}

export default StoreForm;